/* Upgrade cart drawer (2.0 - dev). Vanilla, deferred. No money maths: every figure comes back from
   sections/upgrade-cart-drawer.liquid through the Section Rendering API.
   window.UgCartDrawer = { enabled, open(), close(), refresh() }; listens for `ug:cart:added` and for a click on the
   header cart link. enabled is true only when the drawer section is in the DOM (it is not rendered on /cart).
   Edits: a tap changes the number at once; ONE /cart/update.js goes out 320ms after the last tap (latest intent
   wins; a tap during a request queues the next); only the last response is rendered. Trade-in lines have no
   controls here: the cart page owns that logic. */
(function () {
  'use strict';
  if (window.UgCartDrawer) return;
  var D = document, H = D.documentElement, api = window.UgCartDrawer = { enabled: false, open: nope, close: nope, refresh: nope };
  var sheet = D.getElementById('ug-cd');
  function nope() { return Promise.resolve(false); }
  if (!sheet) return;
  function $(s, c) { return (c || D).querySelector(s); }
  function $$(s, c) { return [].slice.call((c || D).querySelectorAll(s)); }
  function A(n) { return sheet.getAttribute('data-' + n) || ''; }
  function keys(o) { return Object.keys(o); }

  var scrim = $('[data-ug-cd-scrim]'), body = $('[data-ug-cd-body]', sheet), foot = $('[data-ug-cd-foot]', sheet);
  var live = $('[data-ug-cd-live]', sheet), nEl = $('[data-ug-cd-n]', sheet), skel = $('[data-ug-cd-skel]', sheet);
  var SEC = A('sec'), ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var UPD = ((window.routes && routes.cart_update_url) || ROOT + 'cart/update') + '.js';
  var mq = window.matchMedia && matchMedia('(max-width: 479.98px)');
  var isOpen = false, trigger, pending = {}, timer = 0, inflight = false, slowT = 0, gen = 0;

  function bump(el) {
    if (!el) return;
    el.classList.remove('ug-bump'); void el.offsetWidth; el.classList.add('ug-bump');
    setTimeout(function () { el.classList.remove('ug-bump'); }, 400);
  }
  function say(t) { live.textContent = ''; setTimeout(function () { live.textContent = t; }, 60); }
  function line(k) { return $$('[data-ug-cd-line]', body).filter(function (l) { return l.getAttribute('data-key') === k; })[0]; }
  var note;   // the last inline message: kept across a re-render of its line, cleared by the next edit
  function msg(li, t) { var m = li && $('[data-ug-cd-msg]', li); if (m) m.textContent = t; note = t && li ? { k: li.getAttribute('data-key'), t: t } : null; }
  function maxMsg(li) { return A('maxmsg').replace('[quantity]', li.getAttribute('data-max')); }

  /* header badge: the count and its plural-aware label both come from the server render */
  function badge(n, label) {   // the header agent keeps the disc in the DOM ([data-ug-cart-count], hidden at 0)
    var a = $('.ug-header__cart'), b = a && ($('[data-ug-cart-count]', a) || $('.ug-header__cart-count', a)), was;
    if (!a) return;
    if (!b && n > 0) { b = D.createElement('span'); b.className = 'ug-header__cart-count'; a.appendChild(b); }
    if (b) {
      was = b.textContent; b.textContent = n > 0 ? n : ''; b.hidden = !(n > 0);
      if (n > 0 && was !== String(n)) bump(b);
    }
    if (label) a.setAttribute('aria-label', label);
  }

  /* ---- render ---- */
  function clearErr() { var e = $('[data-ug-cd-err]', sheet); if (e) e.remove(); }
  function err(retry) {
    clearErr();
    var d = D.createElement('div');
    d.className = 'ug-cd__err'; d.setAttribute('role', 'alert'); d.setAttribute('data-ug-cd-err', '');
    d.innerHTML = '<p></p><button type="button" class="ug-cd__retry"></button>';
    d.firstChild.textContent = A('err'); d.lastChild.textContent = A('retry');
    d.lastChild.onclick = function () { clearErr(); retry(); };
    body.insertBefore(d, body.firstChild);
  }
  function get() {
    return fetch(ROOT + '?sections=' + SEC, { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function (j) { if (!j[SEC]) throw 0; return j[SEC]; });
  }
  function enter(l, i) {   // a line fades in (staggered); the marks come off again so it compares equal to the server's next render
    l.classList.add('is-new'); l.style.setProperty('--i', i);
    setTimeout(function () { l.classList.remove('is-new'); l.style.removeProperty('--i'); if (!l.getAttribute('style')) l.removeAttribute('style'); }, 900);
  }
  /* a line that did not change stays as it is (focus, photo, scroll); a changed one is replaced; a new one fades in */
  function patch(ol, nl) {
    var old = {}, kids = [], i = 0, n, o, a, b;
    $$('[data-key]', ol).forEach(function (l) { old[l.getAttribute('data-key')] = l; });
    while ((n = nl.firstElementChild)) {
      nl.removeChild(n); o = old[n.getAttribute('data-key')];
      if (o && o.outerHTML === n.outerHTML) n = o;
      else if (o) { a = $('.ug-cd-line__price', o); b = $('.ug-cd-line__price', n); if (a && b && a.textContent !== b.textContent) bump(b); }
      else enter(n, i++);
      kids.push(n);
    }
    kids.forEach(function (k, j) { if (ol.children[j] !== k) ol.insertBefore(k, ol.children[j] || null); });
    while (ol.children.length > kids.length) ol.lastChild.remove();
  }
  function apply(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html'), nb = $('[data-ug-cd-body]', doc), nf = $('[data-ug-cd-foot]', doc);
    if (!nb || !nf) throw 0;
    var a = D.activeElement, li = a && a.closest('[data-ug-cd-line]'), ls, near, t;
    var f = li && { i: $$('[data-ug-cd-line]', body).indexOf(li), k: li.getAttribute('data-key'), s: a.hasAttribute('data-ug-cd-in') ? '[data-ug-cd-in]' : '[data-ug-cd-act="' + a.getAttribute('data-ug-cd-act') + '"]' };
    var ol = $('.ug-cd__list', body), nl = $('.ug-cd__list', nb), sk = body.hasAttribute('data-skel');
    var sub = $('.ug-cd__sub-n', foot), was = sub && sub.textContent, n = +nb.getAttribute('data-count') || 0;
    clearErr();
    if (ol && nl && !sk) patch(ol, nl);
    else if (ol || nl || sk) {
      body.innerHTML = nb.innerHTML;
      $$('.ug-cd-line', body).forEach(enter);
    }
    body.removeAttribute('data-skel'); body.removeAttribute('aria-busy');
    if (foot.innerHTML !== nf.innerHTML) foot.innerHTML = nf.innerHTML;
    foot.hidden = nf.hasAttribute('hidden');
    sub = $('.ug-cd__sub-n', foot); if (sub && was && sub.textContent !== was) bump(sub);
    t = '(' + n + ')'; if (nEl.textContent !== t) { nEl.textContent = t; bump(nEl); } nEl.hidden = !n;
    badge(n, nb.getAttribute('data-label'));
    if (note && line(note.k)) $('[data-ug-cd-msg]', line(note.k)).textContent = note.t;
    if (f) {   // focus was on a control of a line that has been re-rendered or removed: put it back, or on the nearest line
      ls = $$('[data-ug-cd-line]', body); near = ls[Math.min(f.i, ls.length - 1)];
      a = (line(f.k) && $(f.s, line(f.k))) || (near && $('[data-ug-cd-act="rm"],[data-ug-cd-act="keep"]', near)) || $('[data-ug-cd-empty]', body) || sheet;
      try { a.focus({ preventScroll: true }); } catch (e) {}
    }
    return { n: n, label: nb.getAttribute('data-label') };
  }
  function refresh(loud) {
    var g = ++gen;
    return get().then(function (h) { return g === gen && !inflight && !timer ? apply(h) : null; },
      function () { if (loud) err(function () { refresh(true); }); return null; });
  }

  /* ---- editing ---- */
  function mark() {   // aria-busy on the lines in play and on the foot; plates only if it is not near-instant
    $$('[data-ug-cd-line]', body).forEach(function (l) { if (pending.hasOwnProperty(l.getAttribute('data-key'))) l.setAttribute('aria-busy', 'true'); });
    foot.setAttribute('aria-busy', 'true');
    clearTimeout(slowT);
    slowT = setTimeout(function () { $$('[aria-busy="true"] [data-ug-cd-fig]', sheet).forEach(function (e) { e.classList.add('ug-skeleton'); }); }, 160);
  }
  function unmark() {
    clearTimeout(slowT);
    $$('[aria-busy="true"]', sheet).forEach(function (e) { if (e !== body) e.removeAttribute('aria-busy'); });
    $$('.ug-skeleton[data-ug-cd-fig]', sheet).forEach(function (e) { e.classList.remove('ug-skeleton'); });
  }
  function want(key, qty, wait) {
    var li = line(key), inp = li && $('[data-ug-cd-in]', li);
    pending[key] = qty; gen++;   // a render requested before this edit is now stale
    if (inp && qty > 0) inp.value = qty;
    msg(li, ''); clearErr(); mark();
    clearTimeout(timer); timer = setTimeout(flush, wait === undefined ? 320 : wait);
  }
  function flush() {
    var batch = pending; timer = 0;
    if (inflight || !keys(batch).length) return;
    pending = {}; inflight = true;
    fetch(UPD, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: batch, sections: SEC, sections_url: location.pathname }) })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, status: r.status, j: j }; }); })
      .then(function (res) {
        inflight = false;
        if (!res.ok) return fail(res, batch);
        if (keys(pending).length) return flush();   // a newer tap is waiting: skip this render
        gen++;
        var h = res.j.sections && res.j.sections[SEC];
        return (h ? Promise.resolve(h) : get()).then(function (html) {
          var m = apply(html); unmark();
          say(m.n ? m.label : ($('[data-ug-cd-empty]', body) || {}).textContent);
        });
      }).catch(function () { inflight = false; fail(null, batch); });
  }
  function fail(res, batch) {   // put the server's truth back, then say what happened, with a way to retry
    var k = keys(batch)[0];
    get().then(apply).then(function () {
      unmark();
      if (res && res.status === 422 && line(k) && line(k).getAttribute('data-max')) msg(line(k), maxMsg(line(k)));
      else err(function () { keys(batch).forEach(function (x) { pending[x] = batch[x]; }); mark(); flush(); });
    }, function () { unmark(); err(function () { fail(null, batch); }); });
  }

  /* ---- open / close ---- */
  function place() { if (mq) sheet.classList.toggle('ug-sheet--bottom', mq.matches); }
  function inert(on) {   // everything outside the sheet (and its scrim) stops being reachable
    for (var n = sheet; n && n !== D.body; n = n.parentNode) {
      [].forEach.call(n.parentNode.children, function (s) {
        if (s === n || s === scrim || /^(SCRIPT|STYLE|LINK|TEMPLATE)$/.test(s.tagName)) return;
        if (on && !s.inert) { s.inert = true; s.setAttribute('data-ug-cd-inert', ''); }
        else if (!on && s.hasAttribute('data-ug-cd-inert')) { s.inert = false; s.removeAttribute('data-ug-cd-inert'); }
      });
    }
  }
  function skeleton() {
    clearErr(); body.innerHTML = skel.innerHTML; body.setAttribute('data-skel', ''); body.setAttribute('aria-busy', 'true'); foot.hidden = true;
  }
  function open(o) {
    o = o || {};
    if (isOpen) return o.fresh ? (skeleton(), refresh(true)) : Promise.resolve(true);
    var l = $('[data-ug-cd-css]'), t = o.trigger || D.activeElement;
    if (l && l.media !== 'all') l.media = 'all';
    trigger = t && t !== D.body && !sheet.contains(t) ? t : null;
    isOpen = true; place();
    if (o.fresh) skeleton();
    sheet.classList.add('is-open'); scrim.classList.add('is-open'); H.classList.add('ug-lock'); inert(true);
    try { sheet.focus({ preventScroll: true }); } catch (e) {}
    return refresh(!!o.fresh).then(function (m) { if (o.fresh && m) say(A('added')); return true; });
  }
  function close(o) {
    if (!isOpen) return;
    isOpen = false;
    if (timer) { clearTimeout(timer); flush(); }   // an edit made just before closing is not dropped
    sheet.classList.remove('is-open'); scrim.classList.remove('is-open'); H.classList.remove('ug-lock'); inert(false);
    if (!(o && o.silent) && trigger && D.contains(trigger)) { try { trigger.focus({ preventScroll: true }); } catch (e) {} }
    trigger = null;
  }

  /* ---- events ---- */
  D.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var f = $$('a[href]:not([tabindex="-1"]),button:not([disabled]),input:not([disabled])', sheet).filter(function (x) { return x.getClientRects().length; });
    var a = D.activeElement, first = e.shiftKey ? f[f.length - 1] : f[0];
    if (!f.length || !sheet.contains(a) || a === sheet || a === (e.shiftKey ? f[0] : f[f.length - 1])) { e.preventDefault(); (first || sheet).focus(); }
  });
  scrim.addEventListener('click', function () { close(); });
  sheet.addEventListener('click', function (e) {
    var t = e.target.closest('[data-ug-cd-close],[data-ug-cd-act]'), li = t && t.closest('[data-ug-cd-line]'), act;
    if (!t) return;
    if (t.hasAttribute('data-ug-cd-close')) return close();
    act = t.getAttribute('data-ug-cd-act');
    var inp = $('[data-ug-cd-in]', li), cur = inp ? parseInt(inp.value, 10) || 1 : 1, max = +li.getAttribute('data-max') || 0;
    if (act === 'dec' && cur <= 1) return;   // removing is the bin button, never a second tap on minus
    if (act === 'inc' && max && cur >= max) return msg(li, maxMsg(li));
    want(li.getAttribute('data-key'), act === 'rm' ? 0 : act === 'keep' ? 1 : act === 'dec' ? cur - 1 : cur + 1, act === 'inc' || act === 'dec' ? undefined : 0);
  });
  sheet.addEventListener('change', function (e) {
    var t = e.target, li = t.closest('[data-ug-cd-line]'), v = parseInt(t.value, 10), max = li && +li.getAttribute('data-max') || 0;
    if (!li || !t.hasAttribute('data-ug-cd-in')) return;
    if (!(v >= 1)) { t.value = li.getAttribute('data-qty'); return; }
    var clamp = max && v > max;   // the cart API does not refuse a quantity above stock; checkout would
    if (clamp) { v = max; t.value = v; }
    if (v !== +li.getAttribute('data-qty')) want(li.getAttribute('data-key'), v, 0);
    if (clamp) msg(li, maxMsg(li));
  });
  D.addEventListener('click', function (e) {   // header cart link opens the drawer; without JS it is the plain /cart link
    var a = !e.defaultPrevented && !e.button && !(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) && e.target.closest && e.target.closest('a.ug-header__cart');
    if (a) { e.preventDefault(); open({ trigger: a }); }
  });
  D.addEventListener('ug:cart:added', function () { open({ fresh: true }); });
  if (mq) mq.addEventListener ? mq.addEventListener('change', place) : mq.addListener(place);
  addEventListener('pageshow', function (e) { if (e.persisted) { close({ silent: true }); refresh(false); } });   // back/forward cache

  var hl = $('a.ug-header__cart'); if (hl) { hl.setAttribute('aria-haspopup', 'dialog'); hl.setAttribute('aria-controls', 'ug-cd'); }
  place();
  api.enabled = true; api.open = open; api.close = close; api.refresh = function () { return refresh(false); };
})();
